export function formatSizeUnits(bytes: any) {
  if ((bytes >> 30) & 0x3ff)
    bytes = (bytes >>> 30) + "." + (bytes & (3 * 0x3ff)) + "GB";
  else if ((bytes >> 20) & 0x3ff)
    bytes = (bytes >>> 20) + "." + (bytes & (2 * 0x3ff)) + "MB";
  else if ((bytes >> 10) & 0x3ff)
    bytes = (bytes >>> 10) + "." + (bytes & 0x3ff) + "KB";
  else if ((bytes >> 1) & 0x3ff) bytes = (bytes >>> 1) + "Bytes";
  else bytes = bytes + "Byte";
  return bytes;
}
